import { render } from "./MemberTab.vue?vue&type=template&id=344d0bd8"
import script from "./MemberTab.vue?vue&type=script&lang=js"
export * from "./MemberTab.vue?vue&type=script&lang=js"

import exportComponent from "/Users/gabrielalencar/Documents/custom/gestio-school-frontend-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__